import React from 'react';
import { AnimatedSection } from './AnimatedSection';
import { XCircle, Clock } from 'lucide-react';
import { useLanguage } from './LanguageContext';
export function Problem() {
  const {
    t
  } = useLanguage();
  return <AnimatedSection className="bg-barber-dark/50 border-y border-white/5" data-id="element-140">
      <div className="max-w-4xl mx-auto" data-id="element-141">
        <div className="text-center mb-12" data-id="element-142">
          <h2 className="text-4xl md:text-5xl font-oswald font-bold mb-6" data-id="element-143">
            {t.problem.title}
          </h2>
          <div className="flex items-center justify-center gap-3 text-barber-gold text-xl font-medium mb-8" data-id="element-144">
            <Clock size={24} data-id="element-145" />
            <span data-id="element-146">{t.problem.time}</span>
          </div>
          <p className="text-xl text-gray-300 mb-12" data-id="element-147">
            {t.problem.desc1}
            <br data-id="element-148" />
            {t.problem.desc2}
          </p>
        </div>

        <div className="grid md:grid-cols-2 gap-6 mb-12" data-id="element-149">
          <div className="bg-barber-black p-8 rounded-lg border border-red-900/30 flex items-start gap-4" data-id="element-150">
            <XCircle className="text-red-500 shrink-0 mt-1" size={28} data-id="element-151" />
            <div data-id="element-152">
              <h3 className="text-xl font-oswald font-bold mb-2" data-id="element-153">
                {t.problem.opt1Title}
              </h3>
              <p className="text-gray-400" data-id="element-154">{t.problem.opt1Desc}</p>
            </div>
          </div>
          <div className="bg-barber-black p-8 rounded-lg border border-red-900/30 flex items-start gap-4" data-id="element-155">
            <XCircle className="text-red-500 shrink-0 mt-1" size={28} data-id="element-156" />
            <div data-id="element-157">
              <h3 className="text-xl font-oswald font-bold mb-2" data-id="element-158">
                {t.problem.opt2Title}
              </h3>
              <p className="text-gray-400" data-id="element-159">{t.problem.opt2Desc}</p>
            </div>
          </div>
        </div>

        <div className="text-center" data-id="element-160">
          <p className="text-2xl font-oswald text-gray-300" data-id="element-161">
            {t.problem.conclusion1}
          </p>
          <p className="text-3xl font-oswald font-bold text-barber-gold mt-2" data-id="element-162">
            {t.problem.conclusion2}
          </p>
        </div>
      </div>
    </AnimatedSection>;
}